type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'IpAllowed'
const nameSource = 'users/ipAllowed'
const namePageTitle = 'Ips Permitidos'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Ips Permitidos',
  to: '/users/ipAllowed',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/users/ipAllowed/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/users/ipAllowed/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/users/ipAllowed/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
